// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 746 ? "pages-" : chunkId) + "." + {"6":"e69b1347","285":"e2a39b08","746":"7e3d9e57"}[chunkId] + ".chunk.js";
};